export enum RegisterPage {
  Terms = "terms",
  SignUp = "signup",
  PhoneNo = "phone",
  Otp = "otp",
  VerifyAddress = "address",
  Name = "name",
  Email = "email",
  Ssn = "ssn",
  VerifyAge = "age",
}

export const registerSequence = [
  RegisterPage.Terms,
  RegisterPage.Name,
  RegisterPage.VerifyAddress,
  RegisterPage.VerifyAge,
  RegisterPage.Email,
  RegisterPage.Ssn,
  RegisterPage.SignUp
];

export enum MaskTypes {
  PhoneNo = "PhoneNo",
  SSN = "SSN",
  Dollar = "Dollar",
  CreditCardNumber = "CreditCardNumber",
  CreditCardExpiry = "CreditCardExpiry",
  CreditCardCVC = "CreditCardCVC",
  EmployerTaxId = "EmployerTaxId",
  Refund = "Refund",
}

export enum PersonalInfoFormMode {
  Personal = "Personal",
  Spouse = "Spouse",
}

export enum PaymentType {
  CreditCard = "Credit or Debit",
  ECheck = "E Check",
}

export enum FileActionStatus {
  Idle,
  Uploading,
  Deleting,
  Success,
  Error,
}

export enum HTTPRequestStatus {
  Idle,
  Requesting,
  Success,
  Error,
}

export enum FormTypes {
  t1040 = "IRS1040",
  w2 = "IRSW2",
  schedule1 = "IRSSchedule1",
  scheduleC = "IRSScheduleC"
}

export type ICreditCardInfo = {
  nameOnCard: string;
  cardNumber: string;
  cardCVC: string;
  cardExpiry: string;
};

export type IECheckInfo = {
  bankName: string;
  accountNumber: string;
  routingNumber: string;
  accountHolderName: string;
};

// TODO move to final_balance model dir?
export enum BalanceType {
  Due,
  Refund,
}

export enum AddInfoStatus {
  Not_Collected,
  Collecting,
}

export interface SingleFormUpdateStatus {
  id: number,
  status: HTTPRequestStatus,
  message: string,
}

export interface KeyValuePayload {
  key: string,
  value: string
}
